import { cva } from 'class-variance-authority';

/**
 * Styles for LoginPage component
 * Uses responsive CSS classes instead of JavaScript conditionals
 * Matches patterns from RecoverEmailForm
 */
export const loginFormStyles = cva(
  [
    'auth-welcome',
    'w-full',
    'flex',
    'flex-col',
    'gap-0',
    'px-4', // Mobile: 16px horizontal padding both sides
    'pt-0', // No top padding - gap handled by parent spacer
    'pb-0',
    '!mt-0', // Explicitly no top margin - important to override
    'items-start', // Always left align
    'md:gap-8',
    'md:items-center',
    'md:pt-0', // No top padding - gap handled by parent spacer
    'md:pb-0',
    'md:px-0',
    '!md:mt-0', // Explicitly no top margin - important to override
    'lg:gap-8',
    'lg:pt-0', // No top padding - gap handled by parent spacer
    'lg:pb-0',
    '!lg:mt-0', // Explicitly no top margin - important to override
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);

/**
 * Container for form content (card wrapper)
 * Responsive styling via CSS
 * Mobile: no card wrapper (transparent)
 * Tablet: fixed dimensions (334px x 336px) with 32px padding
 * Desktop/Laptop: fixed dimensions (412px x 336px) with 32px padding
 */
export const loginFormContentStyles = cva(
  [
    'w-full', // Mobile: full width
    'px-0', // Mobile: no horizontal padding
    // removed test blue background and border
    // Mobile: no card wrapper
    // Tablet: card wrapper - match personal info screen dimensions
    'md:auth-card',
    'login-card', // Unique class for login page card
    'md:bg-white',
    'md:rounded-2xl',
    'md:shadow-md',
    'md:py-8', // Tablet: 32px vertical padding per Figma
    'md:px-8', // Tablet: 32px horizontal padding per Figma (32px all around)
    'md:max-w-[396px]', // Match personal info screen tablet width
    'md:mx-auto', // Center the card horizontally
    // Desktop: match Figma design - 32px padding all around
    'lg:px-8', // Desktop: 32px horizontal padding per Figma
    'lg:py-8', // Desktop: 32px vertical padding per Figma
    'lg:max-w-[476px]', // Match personal info screen desktop width
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);

/**
 * Error banner container - responsive margin and width matching card
 */
export const loginFormErrorStyles = cva(
  [
    'mt-6',
    'mb-8',
    'w-full',
    // Tablet: match card width (396px) and center - same as personal info screen
    'md:mt-4',
    'md:max-w-[396px]',
    'md:mx-auto',
    // Desktop: match card width (476px) and center - same as personal info screen
    'lg:max-w-[476px]',
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);
